module.exports = __webpack_public_path__ + "img/imgfftBR10.aa9070a9.png";